<p>{{ 'help_and_support.community_care.p1' | translate }}</p>
<p>{{ 'help_and_support.community_care.p1_2' | translate }}</p>

<p>{{ 'help_and_support.community_care.p2' | translate }}</p>
<ul>
  <li>{{ 'help_and_support.community_care.li1' | translate }}</li>
  <li>{{ 'help_and_support.community_care.li2' | translate }}</li>
</ul>

<p>{{ 'help_and_support.community_care.p3' | translate }}</p>
